// This is to handle legacy version of AIFMD code
// Quayside and WCapital are the only clients using this, all future AIFMD clients will use the new version (eg. bflexion)
// This version includes "Market", "Counterparty", "Credit" and "Liquidity" statuses

import React from 'react';
import { useSelector } from 'react-redux';
import useFetchData from '../../../../hooks/useFetchData';
import { GeneralOverviewPageRenderedComponentProps } from '../../../../layout/general/SimpleGeneralPageWrapper';
import GeneralComponentErrorShield from '../../../general/GeneralComponentErrorShield';
import { createSectionByIdSelector } from '../../../../redux/pages/selectors';
import AifmdOverviewTable from './table/table.component';
import { raptorPlatformIdSelector } from '../../../../redux/raptorPlatform/selectors';
import { getSchemaOverviewMonitorURL } from '../../../../routes/endpoints/general.routes';

const AifmdOverviewLegacy: React.FC<
  GeneralOverviewPageRenderedComponentProps
> = (props) => {
  const sectionDetails = useSelector(createSectionByIdSelector(props.section));
  const raptorPlatformId = useSelector(raptorPlatformIdSelector);
  const fundTypes = sectionDetails?.fundTypes;

  const schemas = sectionDetails?.fundTypes.length
    ? `?schemas=${sectionDetails?.fundTypes}`
    : '';
  const reportsList = useFetchData({
    url: `reports_list` + schemas,
    keyName: `${fundTypes}_overview_reports_list`,
    makeFetch: true,
  });

  const url = `/${getSchemaOverviewMonitorURL(props.positionDate || '', fundTypes, raptorPlatformId)}`;

  const overviewData = useFetchData({
    url,
    keyName: url,
    makeFetch: props.positionDate ? true : false,
  });

  return overviewData ? (
    <GeneralComponentErrorShield dataObjects={[overviewData, reportsList]}>
      <AifmdOverviewTable
        reports={reportsList}
        inputData={overviewData}
        section={props.section}
        pageId={props.pageId}
      />
    </GeneralComponentErrorShield>
  ) : null;
};

export default AifmdOverviewLegacy;
